import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IUserRole, RoleType } from '@account-users/user/models/UserRole';
import { Permission } from '@account-users/account/models/Permission';

@Component({
  selector: 'app-user-roles',
  templateUrl: './user-roles.component.html',
  styleUrls: ['./user-roles.component.scss'],
})
export class UserRolesComponent {
  @Input() roles: string[] = [];
  @Input() isEditable = false;
  @Input() isUpdatingRole: boolean;
  @Input() userPermissions: Permission[] = [];
  @Input() userRoles: IUserRole[] = [];
  @Output() updateUserRoles = new EventEmitter<IUserRole>();

  roleTypes = RoleType;
  isEditRoles = false;

  onEditRole() {
    this.isEditRoles = !this.isEditRoles;
  }

  onRoleChange(role: IUserRole) {
    this.updateUserRoles.emit(role);
  }

  get canEditRoles() {
    return this.userPermissions.includes(Permission.CanUpdateRole);
  }

  get hasSuperUserWrite() {
    return this.userPermissions.includes(Permission.CanAddSU);
  }
  get canEditToolTip() {
    return this.canEditRoles ? '' : "You don't have permission to edit roles";
  }

  get nonAccountUserTypeRoles() {
    return this.roles.filter((role) => {
      const uR = this.userRoles.find((ur) => ur.code === role);
      return uR && uR.type === this.roleTypes.User;
    });
  }

  hasRole(role) {
    return this.roles.includes(role);
  }
}
